import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-metric-objective",
  "use": "icon-metric-objective-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-metric-objective\">\n    <rect width=\"24\" height=\"24\" rx=\"6\" fill=\"#FF8541\" />\n    <path d=\"M7.58203 16V7.54492H9.60938L11.9473 13.7324H12.0527L14.3848 7.54492H16.4121V16H14.8359V10.2461H13.9629L15.6504 7.7793L12.5508 16H11.4434L8.34961 7.7793L10.0312 10.2461H9.1582V16H7.58203Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol